
import axios from "axios";
import { Toast } from "antd-mobile";
import nProgress from "nprogress";
import 'nprogress/nprogress.css'
axios.interceptors.request.use((config)=>{
    //可以在请求拦截器里加一下内容
    nProgress.start();
    return config;
})
axios.interceptors.response.use(
    response=>{
        //console.log('=======response:',response.data);
        if(response.data.header.status==='SUCCESS'){
            //console.log('body:',response.data.body);
            nProgress.done();
            return response.data.body;
        }
        if(response.data.header.status==='FAILURE'){
            //console.log(response.data.header.msg);
            nProgress.done(); 
            Toast.show({content: response.data.header.msg,duration: 2000});
            return;
        }
    },
    error => {
        //console.log(error);
        nProgress.done(); 
        Toast.show({content: error.message,duration: 2000});
        return new Promise(()=>{})
    }
)
export default axios;
